<!--
 * @Auther: 罗耀祖
 * @Date: 2021-07-07 18:43:36
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-05-05 11:09:34
 * @name: 后台管理
 * @Description: 后台管理
 * @FilePath: \preSaleNafterSaleBackstage\src\views\jurisdiction\person.vue
 * @Author: DESKTOP-1QU67QM
-->
<template>
  <layout-normal>
    <table-search-form title="人员列表">
      <template v-slot:searchForm>
        <div class="search-form">
          <div class="search-line">
            <div class="search-label">
              <font>用户名</font>
            </div>
            <div class="search-content">
              <el-input
                size="mini"
                v-model="searchForm.search"
                placeholder="请输入用户名"
                @blur="setFocus()"
                @keyup.native.enter="onQuery"
              ></el-input>
            </div>
          </div>
          <!-- <div class="search-line">
            <div class="search-label">
              <font>角色</font>
            </div>
            <div class="search-content">
              <el-select
                size="mini"
                v-model="searchForm.role"
                placeholder="请选择角色"
                @change="onQuery"
              >
                <el-option
                  v-for="item of role_list"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </div>
          </div> -->
          <div class="btn-group">
            <el-button
              size="mini"
              icon="el-icon-search"
              type="primary"
              id="filterSearch"
              @keyup.enter="onQuery"
              @click="onQuery"
              >搜索</el-button
            >
            <el-button
              size="mini"
              icon="el-icon-refresh"
              plain
              @click="initData()"
              >刷新</el-button
            >
          </div>
        </div>
      </template>
      <template v-slot:head>
        <div class="head">
          <el-button size="mini" plain @click="add">添加人员</el-button>
        </div>
      </template>
      <template v-slot:table>
        <el-table
          :data="datas"
          v-loading="loading"
          tooltip-effect="light"
          element-loading-text="数据加载中"
          fit
          :header-cell-style="{
            'background-color': $scssVars['Vars-background-bar-normal'],
            color: '#666',
          }"
          :style="{ fontSize: $scssVars['Vars-font-content-size'] }"
        >
          <el-table-column
            align="center"
            prop="username"
            label="用户名"
          ></el-table-column>
          <el-table-column
            align="center"
            prop="role_ids.text"
            label="角色"
          ></el-table-column>
          <el-table-column
            align="center"
            fixed="right"
            label="操作"
            width="240"
          >
            <template slot-scope="scope">
              <el-button
                size="mini"
                type="text"
                @click="edit(scope.row)"
                :disabled="scope.row.role_ids.value === 'admin'"
                >编辑</el-button
              >
              <font class="clip">|</font>
              <el-button
                size="mini"
                type="text"
                @click="leave(scope.row)"
                :disabled="scope.row.role_ids.value === 'admin'"
                >离职</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </template>
      <template v-slot:pagination>
        <Pagination
          class="pagination"
          v-if="pagination.page"
          :page.sync="pagination.page"
          :page-size.sync="pagination.limit"
          :total="total"
        ></Pagination>
      </template>
    </table-search-form>
    <person-edit-add ref="personEditAdd" @saveSuccess="getTableData"></person-edit-add>
  </layout-normal>
</template>
<script>
import tableSearchForm from "@/components/public/table-search-form.vue";
import personEditAdd from "@/components/role/person-edit-add.vue";
import { confirmation, debounceation } from "@/utils/decorator";
import { adminGetList, adminDelete } from "@/api/admin/admin.api";
export default {
  name: "person",
  components: {
    tableSearchForm,
    personEditAdd,
  },
  data() {
    return {
      searchForm: {
        search: "",
      },
      role_list: [], //权限列表
      pagination: {}, //分页器信息
      datas: [], //表格数据
      total: 0, //表格总行数
      loading: false, //加载中
    };
  },
  watch: {
    //分页数据发送变化查询表格数据
    pagination: {
      handler(nv, ov) {
        nv.page && this.getTableData();
      },
      immediate: false,
      deep: true,
    },
  },
  activated() {
    this.initData(); //初始化数据
  },
  methods: {
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 置焦点于搜索框
     */
    setFocus() {
      document.getElementById("filterSearch").focus();
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 点击搜索框
     */
    @debounceation(300)
    onQuery() {
      this.initPagination();
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 初始化数据
     */
    @debounceation(300)
    initData() {
      this.initSearchForm(); //初始化搜索条件表单
      this.initPagination(); //初始化分页信息
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 初始化搜索条件表单
     */
    initSearchForm() {
      this.searchForm = {
        search: "",
      };
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 初始化分页信息
     */
    initPagination() {
      this.pagination = {
        page: 1,
        limit: 10,
      };
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 获取表格数据
     */
    getTableData() {
      let params = { ...this.searchForm, ...this.pagination };
      adminGetList(params).then((res) => {
        this.datas = res.data.data;
        this.total = res.data.total;
      });
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 点击入职
     */
    @debounceation(300)
    add() {
      this.$refs.personEditAdd.open();
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 点击编辑
     * @param {Object} row 产品行数据
     */
    @debounceation(300)
    edit(row) {
      this.$refs.personEditAdd.open(row.id);
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 点击删除
     * @param {Object} row 产品行数据
     */
    @confirmation("确认离职?")
    leave(row) {
      adminDelete({
        id: row.id,
      }).then((res) => {
        this.getTableData();
      });
    },
  },
};
</script>
<style lang="scss" scoped>
</style>